/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiPortfolioCreatePortfolioPost } from '../fn/portfolio/api-portfolio-create-portfolio-post';
import { ApiPortfolioCreatePortfolioPost$Params } from '../fn/portfolio/api-portfolio-create-portfolio-post';
import { apiPortfolioCreatePortfolioPost$Plain } from '../fn/portfolio/api-portfolio-create-portfolio-post-plain';
import { ApiPortfolioCreatePortfolioPost$Plain$Params } from '../fn/portfolio/api-portfolio-create-portfolio-post-plain';
import { apiPortfolioDeletePortfolioDelete } from '../fn/portfolio/api-portfolio-delete-portfolio-delete';
import { ApiPortfolioDeletePortfolioDelete$Params } from '../fn/portfolio/api-portfolio-delete-portfolio-delete';
import { apiPortfolioDeletePortfolioDelete$Plain } from '../fn/portfolio/api-portfolio-delete-portfolio-delete-plain';
import { ApiPortfolioDeletePortfolioDelete$Plain$Params } from '../fn/portfolio/api-portfolio-delete-portfolio-delete-plain';
import { apiPortfolioGetPortfolioGet } from '../fn/portfolio/api-portfolio-get-portfolio-get';
import { ApiPortfolioGetPortfolioGet$Params } from '../fn/portfolio/api-portfolio-get-portfolio-get';
import { apiPortfolioGetPortfolioGet$Plain } from '../fn/portfolio/api-portfolio-get-portfolio-get-plain';
import { ApiPortfolioGetPortfolioGet$Plain$Params } from '../fn/portfolio/api-portfolio-get-portfolio-get-plain';
import { apiPortfolioGetPortfoliosPost } from '../fn/portfolio/api-portfolio-get-portfolios-post';
import { ApiPortfolioGetPortfoliosPost$Params } from '../fn/portfolio/api-portfolio-get-portfolios-post';
import { apiPortfolioGetPortfoliosPost$Plain } from '../fn/portfolio/api-portfolio-get-portfolios-post-plain';
import { ApiPortfolioGetPortfoliosPost$Plain$Params } from '../fn/portfolio/api-portfolio-get-portfolios-post-plain';
import { apiPortfolioUpdatePortfolioPatch } from '../fn/portfolio/api-portfolio-update-portfolio-patch';
import { ApiPortfolioUpdatePortfolioPatch$Params } from '../fn/portfolio/api-portfolio-update-portfolio-patch';
import { apiPortfolioUpdatePortfolioPatch$Plain } from '../fn/portfolio/api-portfolio-update-portfolio-patch-plain';
import { ApiPortfolioUpdatePortfolioPatch$Plain$Params } from '../fn/portfolio/api-portfolio-update-portfolio-patch-plain';
import { CreatePortfolioCommandResult } from '../models/create-portfolio-command-result';
import { DeletePortfolioCommandResult } from '../models/delete-portfolio-command-result';
import { GetPortfolioQueryResult } from '../models/get-portfolio-query-result';
import { GetPortfoliosQueriesResult } from '../models/get-portfolios-queries-result';
import { UpdatePortfolioCommandResult } from '../models/update-portfolio-command-result';

@Injectable({ providedIn: 'root' })
export class PortfolioService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiPortfolioGetPortfolioGet()` */
  static readonly ApiPortfolioGetPortfolioGetPath = '/api/Portfolio/GetPortfolio';

  /**
   * دي بترجعلك بورتفوليو واحد بس.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortfolioGetPortfolioGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortfolioGetPortfolioGet$Plain$Response(params: ApiPortfolioGetPortfolioGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPortfolioQueryResult>> {
    return apiPortfolioGetPortfolioGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دي بترجعلك بورتفوليو واحد بس.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPortfolioGetPortfolioGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortfolioGetPortfolioGet$Plain(params: ApiPortfolioGetPortfolioGet$Plain$Params, context?: HttpContext): Observable<GetPortfolioQueryResult> {
    return this.apiPortfolioGetPortfolioGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPortfolioQueryResult>): GetPortfolioQueryResult => r.body)
    );
  }

  /**
   * دي بترجعلك بورتفوليو واحد بس.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortfolioGetPortfolioGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortfolioGetPortfolioGet$Response(params: ApiPortfolioGetPortfolioGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPortfolioQueryResult>> {
    return apiPortfolioGetPortfolioGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دي بترجعلك بورتفوليو واحد بس.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPortfolioGetPortfolioGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortfolioGetPortfolioGet(params: ApiPortfolioGetPortfolioGet$Params, context?: HttpContext): Observable<GetPortfolioQueryResult> {
    return this.apiPortfolioGetPortfolioGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPortfolioQueryResult>): GetPortfolioQueryResult => r.body)
    );
  }

  /** Path part for operation `apiPortfolioGetPortfoliosPost()` */
  static readonly ApiPortfolioGetPortfoliosPostPath = '/api/Portfolio/GetPortfolios';

  /**
   * دي بترجعلك ليست من البورتفوليوز من غير ولادها
   * if companyId == null it will return all portfolios.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortfolioGetPortfoliosPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioGetPortfoliosPost$Plain$Response(params?: ApiPortfolioGetPortfoliosPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPortfoliosQueriesResult>> {
    return apiPortfolioGetPortfoliosPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دي بترجعلك ليست من البورتفوليوز من غير ولادها
   * if companyId == null it will return all portfolios.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPortfolioGetPortfoliosPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioGetPortfoliosPost$Plain(params?: ApiPortfolioGetPortfoliosPost$Plain$Params, context?: HttpContext): Observable<GetPortfoliosQueriesResult> {
    return this.apiPortfolioGetPortfoliosPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPortfoliosQueriesResult>): GetPortfoliosQueriesResult => r.body)
    );
  }

  /**
   * دي بترجعلك ليست من البورتفوليوز من غير ولادها
   * if companyId == null it will return all portfolios.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortfolioGetPortfoliosPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioGetPortfoliosPost$Response(params?: ApiPortfolioGetPortfoliosPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPortfoliosQueriesResult>> {
    return apiPortfolioGetPortfoliosPost(this.http, this.rootUrl, params, context);
  }

  /**
   * دي بترجعلك ليست من البورتفوليوز من غير ولادها
   * if companyId == null it will return all portfolios.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPortfolioGetPortfoliosPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioGetPortfoliosPost(params?: ApiPortfolioGetPortfoliosPost$Params, context?: HttpContext): Observable<GetPortfoliosQueriesResult> {
    return this.apiPortfolioGetPortfoliosPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetPortfoliosQueriesResult>): GetPortfoliosQueriesResult => r.body)
    );
  }

  /** Path part for operation `apiPortfolioCreatePortfolioPost()` */
  static readonly ApiPortfolioCreatePortfolioPostPath = '/api/Portfolio/CreatePortfolio';

  /**
   * دا علشان تنشئ بورتفوليو اللي تحتيه مجموعه من البرامج اللي جواها مجموعه مشاريع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortfolioCreatePortfolioPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioCreatePortfolioPost$Plain$Response(params?: ApiPortfolioCreatePortfolioPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePortfolioCommandResult>> {
    return apiPortfolioCreatePortfolioPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تنشئ بورتفوليو اللي تحتيه مجموعه من البرامج اللي جواها مجموعه مشاريع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPortfolioCreatePortfolioPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioCreatePortfolioPost$Plain(params?: ApiPortfolioCreatePortfolioPost$Plain$Params, context?: HttpContext): Observable<CreatePortfolioCommandResult> {
    return this.apiPortfolioCreatePortfolioPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreatePortfolioCommandResult>): CreatePortfolioCommandResult => r.body)
    );
  }

  /**
   * دا علشان تنشئ بورتفوليو اللي تحتيه مجموعه من البرامج اللي جواها مجموعه مشاريع.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortfolioCreatePortfolioPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioCreatePortfolioPost$Response(params?: ApiPortfolioCreatePortfolioPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePortfolioCommandResult>> {
    return apiPortfolioCreatePortfolioPost(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تنشئ بورتفوليو اللي تحتيه مجموعه من البرامج اللي جواها مجموعه مشاريع.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPortfolioCreatePortfolioPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioCreatePortfolioPost(params?: ApiPortfolioCreatePortfolioPost$Params, context?: HttpContext): Observable<CreatePortfolioCommandResult> {
    return this.apiPortfolioCreatePortfolioPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreatePortfolioCommandResult>): CreatePortfolioCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPortfolioUpdatePortfolioPatch()` */
  static readonly ApiPortfolioUpdatePortfolioPatchPath = '/api/Portfolio/UpdatePortfolio';

  /**
   * دا علشان تعدل ع البورتفوليو.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortfolioUpdatePortfolioPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioUpdatePortfolioPatch$Plain$Response(params?: ApiPortfolioUpdatePortfolioPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePortfolioCommandResult>> {
    return apiPortfolioUpdatePortfolioPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تعدل ع البورتفوليو.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPortfolioUpdatePortfolioPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioUpdatePortfolioPatch$Plain(params?: ApiPortfolioUpdatePortfolioPatch$Plain$Params, context?: HttpContext): Observable<UpdatePortfolioCommandResult> {
    return this.apiPortfolioUpdatePortfolioPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdatePortfolioCommandResult>): UpdatePortfolioCommandResult => r.body)
    );
  }

  /**
   * دا علشان تعدل ع البورتفوليو.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortfolioUpdatePortfolioPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioUpdatePortfolioPatch$Response(params?: ApiPortfolioUpdatePortfolioPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePortfolioCommandResult>> {
    return apiPortfolioUpdatePortfolioPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تعدل ع البورتفوليو.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPortfolioUpdatePortfolioPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioUpdatePortfolioPatch(params?: ApiPortfolioUpdatePortfolioPatch$Params, context?: HttpContext): Observable<UpdatePortfolioCommandResult> {
    return this.apiPortfolioUpdatePortfolioPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdatePortfolioCommandResult>): UpdatePortfolioCommandResult => r.body)
    );
  }

  /** Path part for operation `apiPortfolioDeletePortfolioDelete()` */
  static readonly ApiPortfolioDeletePortfolioDeletePath = '/api/Portfolio/DeletePortfolio';

  /**
   * دا علشان تمسح البورتفوليو.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortfolioDeletePortfolioDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioDeletePortfolioDelete$Plain$Response(params?: ApiPortfolioDeletePortfolioDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletePortfolioCommandResult>> {
    return apiPortfolioDeletePortfolioDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تمسح البورتفوليو.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPortfolioDeletePortfolioDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioDeletePortfolioDelete$Plain(params?: ApiPortfolioDeletePortfolioDelete$Plain$Params, context?: HttpContext): Observable<DeletePortfolioCommandResult> {
    return this.apiPortfolioDeletePortfolioDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeletePortfolioCommandResult>): DeletePortfolioCommandResult => r.body)
    );
  }

  /**
   * دا علشان تمسح البورتفوليو.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortfolioDeletePortfolioDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioDeletePortfolioDelete$Response(params?: ApiPortfolioDeletePortfolioDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletePortfolioCommandResult>> {
    return apiPortfolioDeletePortfolioDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * دا علشان تمسح البورتفوليو.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiPortfolioDeletePortfolioDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiPortfolioDeletePortfolioDelete(params?: ApiPortfolioDeletePortfolioDelete$Params, context?: HttpContext): Observable<DeletePortfolioCommandResult> {
    return this.apiPortfolioDeletePortfolioDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeletePortfolioCommandResult>): DeletePortfolioCommandResult => r.body)
    );
  }

}
